<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12 w-100">
            <h3 class="title">
                <span *ngIf="newWhiteLabelProvider" translate="Settings.WhiteLabelProviderEditSection.AddWhiteLabelProvider"></span>
                <span *ngIf="!newWhiteLabelProvider" translate="Settings.WhiteLabelProviderEditSection.EditWhiteLabelProvider"></span>
            </h3>
        </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="p-4 pt-1">
            <div class="mb-3 col-12">
                <label for="WhiteLabelProviderName" class="form-label" translate="Settings.WhiteLabelProviderEditSection.WhiteLabelProviderName"></label>
                <input type="text" id="WhiteLabelProviderName" class="form-control" [value]="whiteLabelProviderName">
            </div>
            <div class="mb-3 col-12">
                <label for="Organisations" class="form-label" translate="Settings.WhiteLabelProviderEditSection.Organisations"></label>
                <input type="text" id="Organisations" class="form-control" [value]="organisations">
            </div>
            <div class="mb-3 col-12">
                <label for="AccountLicenses" class="form-label" translate="Settings.WhiteLabelProviderEditSection.AccountLicenses"></label>
                <input type="text" id="AccountLicenses" class="form-control" [value]="accountLicenses">
            </div>

            <div class="col-12 mt-4 pb-2 d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()" translate="Button.Back"></button></span>
                <span class="float-end"><button type="submit" class="btn btn-sm btn-primary" translate="Button.Save"></button></span>
            </div>
        </div>
    </form>
</div>